export class FolderHistoryQuery {
  constructor () {
    this.current = undefined;
    this.pageSize = undefined;
  }
}
